<template>
    <d-card-body>
        <d-list-group flush>
            <d-form>
                <h3 class="mt-2 mb-4">Nowa sprawa</h3>
            </d-form>
            <d-row>
                <d-col md="6">
                    <fieldset class="form-group">
                        <label>Wybierz dłużnika z listy</label>
                        <d-select
                                type="text"
                                name="guarantor_id"
                                v-model="execution.guarantor_id"
                                :class="{'is-invalid' : lar_errors.has('guarantor_id') }"
                                placeholder="Wpisz dane dłużnika...">
                            <option :value="0">Pożyczkobiorca</option>
                            <option :value="guarantor.id" v-for="guarantor in guarantors" :key="guarantor.id">
                                {{ guarantor.name }}
                            </option>
                        </d-select>
                        <div class="invalid-feedback" v-text="lar_errors.get('guarantor_id')"></div>
                    </fieldset>
                </d-col>
                <d-col md="6">
                    <fieldset class="form-group">
                        <label>Wybierz komornika z listy</label>
                        <div class="d-flex" :class="{'is-invalid' : lar_errors.has('bailiff_id') }">
                            <d-select
                                    class="w-100"
                                    v-model="execution.bailiff_id"
                                    @input="lar_errors.clear('bailiff_id')"
                                    placeholder="Wpisz dane komornika...">
                                <option :value="ballif.id" v-for="ballif in allBailiffs" :key="ballif.id">
                                    {{ ballif.name }}
                                </option>
                            </d-select>
                            <d-button class="wsnw ml-4" @click.prevent="newBailiffModal = true">Dodaj komornika</d-button>
                        </div>
                        <div class="invalid-feedback" :class="{'d-block': lar_errors.get('bailiff_id')}" v-text="lar_errors.get('bailiff_id')"></div>
                    </fieldset>
                </d-col>
            </d-row>
            <d-row>
                <d-col md="6">
                    <fieldset class="form-group">
                        <label>Data nadania wniosku do komornika</label>
                        <ss-date type="text"
                                 name="send_date"
                                 v-model="execution.send_date"
                                 placeholder=""/>
                        <div class="invalid-feedback" :class="{'d-block': lar_errors.get('send_date')}" v-text="lar_errors.get('send_date')"></div>
                    </fieldset>
                </d-col>
                <d-col md="6">
                    <fieldset class="form-group">
                        <label>Data nadania klauzuli</label>
                        <ss-date type="text"
                                 name="release_date"
                                 v-model="execution.release_date"
                                 placeholder=""/>
                        <div class="invalid-feedback" :class="{'d-block': lar_errors.get('release_date')}" v-text="lar_errors.get('release_date')"></div>
                    </fieldset>

                </d-col>
            </d-row>
            <d-row>
                <d-col md="6">
                    <fieldset class="form-group">
                        <label>Zaznacz czynności jakimi ma się zająć komornik:</label>
                        <div v-for="application in allApplications">
                            <d-checkbox :value="application" v-model="execution.applications">{{ application.name }}</d-checkbox>
                        </div>
                        <d-checkbox v-model="other_applications">Inne</d-checkbox>
                        <template v-if="other_applications">
                            <div class="d-flex" @keyup.enter="addNewApplication">
                                <d-input ref="newApplicationInput" v-model="new_application"></d-input>
                                <d-button class="wsnw" @click.prevent="addNewApplication">Dodaj do listy</d-button>
                            </div>
                            <div class="d-flex justify-content-between mt-3 mb-0" v-for="(new_app, index) in execution.new_applications" :key="'new_app-' + index">
                                <span>{{ new_app}}</span><a href="#" class="badge-danger badge text-white" @click.prevent="removeNewApplication(index)"><i class="material-icons">delete</i></a>
                            </div>
                        </template>
                    </fieldset>
                </d-col>
                <d-col md="6">
                    <fieldset class="form-group">
                        <label>Numer listu przewozowego</label>
                        <ss-input type="text"
                                  name=""
                                  v-model="execution.consignment_number"
                                  placeholder=""/>
                    </fieldset>
                    <fieldset class="form-group">
                        <label>Data odbioru wniosku przez komornika</label>
                        <ss-date type="text"
                                 name="receipt_date"
                                 v-model="execution.receipt_date"
                                 placeholder=""/>
                        <div class="invalid-feedback" :class="{'d-block': lar_errors.get('receipt_date')}" v-text="lar_errors.get('receipt_date')"></div>
                    </fieldset>
                </d-col>
            </d-row>
        </d-list-group>
        <ss-modal
                class="xl"
                v-if="newBailiffModal"
                title="Title"
                intro="bounceIn"
                outro ="bounceOut">
            <div slot = "modal-header">
                Dodawanie komornika
            </div>
            <div slot="modal-body">
                <bailiff-form></bailiff-form>
            </div>
            <div slot = "modal-footer">
                <d-button @click.prevent="newBailiffModal = false" theme="danger"><i class="material-icons">close</i> Anuluj</d-button>
                <d-button @click.prevent="addNewBailiff" theme="success" class="ml-4"><i class="material-icons">save</i> Zapisz komornika</d-button>
            </div>
        </ss-modal>
    </d-card-body>
</template>


<script>
  import LarErrors from '../../helpers/Errors'
  import SsDate from '../common/SsDate'
  import SsModal from '../common/SsModal'
  import BailiffForm from '../bailiffs/BailiffForm'
  import ExecutionUtils from '../../utils/execution'
  import { mapGetters, mapActions } from 'vuex'

  export default {
    name: "ExecutionNew",
    components: {
      SsDate,
      BailiffForm,
      SsModal
    },
    props: {
      guarantors: {
        default: () => [],
        type: Array
      },
      client: {
        default: () => {},
        type: Object
      }
    },
    data(){
      return{
        fetched: true,
        newBailiffModal: false,
        lar_errors: LarErrors,
        new_application: '',
        is_client_case: false,
        other_applications: false,
        execution: _.clone(ExecutionUtils),
      }
    },
    computed: {
      ...mapGetters([
        'allBailiffs',
        'allApplications'
      ])
    },
    methods: {
      ...mapActions([
        'getAllBailiffs'
      ]),
      submitForm() {
        this.axios.post('api/contracts-case/add-case', this.execution).then(response => {
          this.$bus.$emit('execution-added', response.data.data.id)
        }).catch(error => {
          this.$bus.$emit('execution-failed');
          LarErrors.record(error.response.data.errors)
        })
      },
      addNewApplication() {
        this.execution.new_applications.push(this.new_application);
        this.new_application = '';
        this.$refs.newApplicationInput.$el.focus()
      },
      removeNewApplication(index) {
        this.execution.new_applications.splice(index, 1);
        this.$forceUpdate()
      },
      addNewBailiff() {
        this.$bus.$emit('new-bailiff-save')
      },
      newBailiffAdded(bailiff) {
        this.getAllBailiffs();
        this.newBailiffModal = false;
        this.execution.bailiff_id = bailiff.id
      }
    },
    mounted(){
      this.execution.client_id = this.$route.params.client_id;
      this.execution.schedule_id = this.$route.params.schedule_id;
      this.$bus.$on('new-bailiff-saved', this.newBailiffAdded);
      this.$bus.$on('new-execution-save', this.submitForm);
      this.fetched = true;
    },
    beforeDestroy() {
      this.$bus.$off('new-bailiff-saved', this.newBailiffAdded);
      this.$bus.$off('new-execution-save', this.submitForm);
      this.execution = _.clone(ExecutionUtils);
      this.execution.new_applications = []
    }
  }
</script>
